export default __webpack_public_path__ + "static/media/logo.039e6ac6.png";